module.exports = __webpack_public_path__ + "static/media/income-icon.20226d2d.svg";


//////////////////
// WEBPACK FOOTER
// ./public/img/income-icon.svg
// module id = 878
// module chunks = 0 1